module.exports = __webpack_public_path__ + "img/二维码背景3.ac9c0392.png";